module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1528-a9d622c5f531f24f2d95360a9a46868b.png";